import Swiper from 'swiper';
import {Navigation, Pagination, Autoplay, A11y, Keyboard} from 'swiper/modules';
export class Slider {

    constructor(slider, config = '') {
        this.slider = slider;
        this.config = this.parseConfig(config);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.defaultConfig = {
            modules: [Navigation, Pagination, Autoplay, A11y, Keyboard],
            rewind: true,
            speed: this.reducedMotion ? 0 : 500,
            spaceBetween: 24,
            slidesPerView: 1,
            breakpoints: {
                576: {},
                768: {},
                992: {},
                1330: {},
            },
            a11y: {
                enabled: true,
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                nextSlideMessage: 'Next slide',
                prevSlideMessage: 'Previous slide',
                paginationBulletMessage: 'Go to slide {{index}}',
            },
            keyboard: {
                enabled: true
            },
        }

        return this.init();
    }

    parseConfig(config) {
        try {
            return JSON.parse(config);
        } catch (e) {
            return null;
        }
    }

    resolveDirection() {
        const main = document.querySelector('main');
        const overwrite = main && main.getAttribute('dir');
        return overwrite || document.querySelector('html').getAttribute('dir') || 'ltr';
    }

    init() {
        const options = this.defaultConfig;
        options.rtl = this.resolveDirection() === 'rtl';

        if (this.config) {
            if (this.config.slidesPerView?.xs) {
                options.slidesPerView = this.config.slidesPerView.xs;
                options.slidesPerGroup = this.config.slidesPerView.xs;
            }
            if (this.config.slidesPerView?.sm) {
                options.breakpoints["576"].slidesPerView = this.config.slidesPerView.sm;
                options.breakpoints["576"].slidesPerGroup = this.config.slidesPerView.sm;
            }
            if (this.config.slidesPerView?.md) {
                options.breakpoints["768"].slidesPerView = this.config.slidesPerView.md;
                options.breakpoints["768"].slidesPerGroup = this.config.slidesPerView.md;
            }
            if (this.config.slidesPerView?.lg) {
                options.breakpoints["992"].slidesPerView = this.config.slidesPerView.lg;
                options.breakpoints["992"].slidesPerGroup = this.config.slidesPerView.lg;
            }
            if (this.config.slidesPerView?.xl) {
                options.breakpoints["1330"].slidesPerView = this.config.slidesPerView.xl;
                options.breakpoints["1330"].slidesPerGroup = this.config.slidesPerView.xl;
            }
            if (this.config.spaceBetween) {
                options.spaceBetween = this.config.spaceBetween;
            }
            if (this.config.rewind !== undefined) {
                options.rewind = this.config.rewind;
            }
            if (this.config.autoplay?.enabled && !this.reducedMotion) {
                options.autoplay = {
                    delay: (this.config.autoplay.delaySeconds || 5) * 1000,
                    pauseOnMouseEnter: !!this.config.autoplay.pauseOnHover,
                }
            }
            if (this.config.arrows && this.config.arrows !== 'none') {
                options.navigation = {
                    prevEl: this.slider.querySelector('.swiper-button-prev'),
                    nextEl: this.slider.querySelector('.swiper-button-next'),
                    addIcons: false,
                };
            }
            if (this.config.bullets && this.config.bullets !== 'none') {
                options.pagination = {
                    el: this.slider.querySelector('.swiper-pagination'),
                    clickable: true,
                }
            }
            if (this.config.a11y) {
                Object.entries(this.config.a11y).forEach(([key, value]) => {
                    if (value) {
                        options.a11y[key] = value;
                    }
                });
            }
        }

        const swiper = new Swiper(this.slider, options);

        if (this.slider.querySelectorAll('video').length) {
            swiper.on('slideChange', (swpr) => {
                const previousSlide = swpr.slides[swpr.previousIndex];
                if (previousSlide) {
                    previousSlide.querySelectorAll('video').forEach(video => {
                        video.pause();
                    });
                }
            });
        }

        return swiper;
    }
}